import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AppProvider } from "@/context/AppContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import AppLayout from "@/components/AppLayout";
import { Login, Register } from "@/pages/Auth";
import Onboarding from "@/pages/Onboarding";
import Dashboard from "@/pages/Dashboard";
import ComingSoon from "@/pages/ComingSoon";
import Clients from "@/pages/Clients";
import Suppliers from "@/pages/Suppliers";
import Products from "@/pages/Products";
import Quotes from "@/pages/Quotes";
import Invoices from "@/pages/Invoices";
import Payments from "@/pages/Payments";
import Expenses from "@/pages/Expenses";
import Treasury from "@/pages/Treasury";
import Accounting from "@/pages/Accounting";
import POS from "@/pages/POS";
import Relances from "@/pages/Relances";
import Purchasing from "@/pages/Purchasing";
import Recurring from "@/pages/Recurring";
import Copilot from "@/pages/Copilot";
import Catalog from "@/pages/Catalog";
import HR from "@/pages/HR";
import Reports from "@/pages/Reports";
import Budgets from "@/pages/Budgets";
import AdminCompanies from "@/pages/AdminCompanies";

function Shell({ children }) {
  return (
    <ProtectedRoute>
      <AppLayout>{children}</AppLayout>
    </ProtectedRoute>
  );
}

function App() {
  return (
    <div className="App">
      <AppProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="/onboarding" element={<ProtectedRoute requireCompany={false}><Onboarding /></ProtectedRoute>} />
            <Route path="/dashboard" element={<Shell><Dashboard /></Shell>} />
            <Route path="/clients" element={<Shell><Clients /></Shell>} />
            <Route path="/fournisseurs" element={<Shell><Suppliers /></Shell>} />
            <Route path="/produits" element={<Shell><Products /></Shell>} />
            <Route path="/devis" element={<Shell><Quotes /></Shell>} />
            <Route path="/factures" element={<Shell><Invoices /></Shell>} />
            <Route path="/paiements" element={<Shell><Payments /></Shell>} />
            <Route path="/depenses" element={<Shell><Expenses /></Shell>} />
            <Route path="/tresorerie" element={<Shell><Treasury /></Shell>} />
            <Route path="/comptabilite" element={<Shell><Accounting /></Shell>} />
            <Route path="/pos" element={<Shell><POS /></Shell>} />
            <Route path="/relances" element={<Shell><Relances /></Shell>} />
            <Route path="/achats" element={<Shell><Purchasing /></Shell>} />
            <Route path="/abonnements" element={<Shell><Recurring /></Shell>} />
            <Route path="/copilot" element={<Shell><Copilot /></Shell>} />
            <Route path="/rh" element={<Shell><HR /></Shell>} />
            <Route path="/rapports" element={<Shell><Reports /></Shell>} />
            <Route path="/budgets" element={<Shell><Budgets /></Shell>} />
            <Route path="/admin" element={<Shell><AdminCompanies /></Shell>} />
            <Route path="/catalog/:companyId" element={<Catalog />} />
            <Route path="/module/:name" element={<Shell><ComingSoon /></Shell>} />
            <Route path="/" element={<Navigate to="/dashboard" replace />} />
            <Route path="*" element={<Navigate to="/dashboard" replace />} />
          </Routes>
          <Toaster position="bottom-right" richColors />
        </BrowserRouter>
      </AppProvider>
    </div>
  );
}

export default App;
